// extracted by mini-css-extract-plugin
export default {"personAvatar":"Placeholder__personAvatar___S6zzB","placeholderIcon":"Placeholder__placeholderIcon___UU0uj"};